import {Component, NgModule, Input} from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import { Homepage } from '../homepage/homepage';

@Component({
  selector: 'app-pricing-landing',
  templateUrl: './pricing-landing.html',
  styleUrls: ['./pricing-landing.scss']
})
export class PricingLanding {
  @Input() homepage : Homepage;
}

@NgModule({
  imports: [ MatIconModule, MatButtonModule, MatToolbarModule, MatListModule ],
  exports: [PricingLanding],
  declarations: [PricingLanding],
})
export class PricingLandingModule {}